<a class="skip-link" href="#main">Aller au contenu</a>
<header class="site-header">
  <div class="container header-inner">
    <a class="brand" routerLink="/" aria-label="Accueil Mesh Box" (click)="isMenuOpen.set(false)">
      <img src="/assets/mesh_box.png" class="logo-dark" alt="Logo Agence Mesh Box - Développement Web & Mobile" />
      <img src="/assets/mesh_box_dark.png" class="logo-light" alt="Logo Agence Mesh Box - Développement Web & Mobile" />
    </a>

    <button 
      class="burger-button"
      [class.active]="isMenuOpen()"
      (click)="toggleMenu()"
      aria-label="Menu"
      [attr.aria-expanded]="isMenuOpen()"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav class="nav" [class.open]="isMenuOpen()" aria-label="Navigation principale">
      <a routerLink="/maintenance-tma-nodejs-angular" (click)="isMenuOpen.set(false)">Maintenance</a>
      <a routerLink="/refonte-modernisation-legacy" (click)="isMenuOpen.set(false)">Modernisation</a>
      <a routerLink="/integration-ia" (click)="isMenuOpen.set(false)">Solutions IA</a>
      <a routerLink="/ressources" (click)="isMenuOpen.set(false)">News</a>
      <a routerLink="/contact" (click)="isMenuOpen.set(false)">Contact</a>
      
      <a 
        href="https://cal.mesh-box.fr/ogirodin/30min"
        target="_blank"
        rel="noopener"
        class="button primary header-cta"
        (click)="isMenuOpen.set(false)"
      >
        Diagnostic
      </a>
      <button 
          id="themeToggle" 
          class="theme-toggle" 
          aria-label="Basculer le thème" 
          title="Thème clair/sombre"
          (click)="toggleTheme()"
      >
          <span class="icon-sun">☼</span>
          <span class="icon-moon">☾</span>
      </button>
    </nav>
  </div>
</header>

<main id="main">
  <router-outlet></router-outlet>
</main>

<footer class="site-footer">
  <div class="container">
    <div class="footer-columns" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 2rem; margin-bottom: 2rem;">
      <div class="col">
          <img src="/assets/mesh_box.png" class="logo-dark" alt="Logo Mesh Box bas de page" style="max-width: 150px; margin-bottom: 1rem;" />
          <img src="/assets/mesh_box_dark.png" class="logo-light" alt="Logo Mesh Box bas de page" style="max-width: 150px; margin-bottom: 1rem;" />
          <p style="color: var(--muted); font-size: 0.9rem;">Expertise Node.js & Angular pour les entreprises exigeantes.</p>
          <div class="mt-3">
            <app-cii-badge variant="compact" />
          </div>
      </div>

      <div class="col">
          <h4 style="margin-bottom: 1rem;">Nos Bureaux</h4>
          <p style="color: var(--muted); font-size: 0.9rem; margin-bottom: 1rem;">
            <strong>Paris</strong><br/>
            6 rue d'Armaillé<br/>
            75017 Paris
          </p>
          <p style="color: var(--muted); font-size: 0.9rem;">
            <strong>Centre-Val de Loire</strong><br/>
            72 rue Louis Lumière<br/>
            36000 Châteauroux
          </p>
      </div>

      <div class="col">
          <h4 style="margin-bottom: 1rem;">Expertises</h4>
          <ul style="list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.5rem;">
              <li><a routerLink="/tma-nodejs" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">TMA Node.js / NestJS</a></li>
              <li><a routerLink="/tma-angular" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">TMA Angular</a></li>
              <li><a routerLink="/tma-android" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">TMA Android</a></li>
              <li><a routerLink="/refonte-modernisation-legacy" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Modernisation Legacy</a></li>
              <li><a routerLink="/integration-ia" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Intégration IA / RAG</a></li>
          </ul>
      </div>

      <div class="col">
          <h4 style="margin-bottom: 1rem;">Solutions & Agence</h4>
          <ul style="list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.5rem;">
              <li><a routerLink="/solutions/migration-angularjs-vers-angular" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Migration AngularJS</a></li>
              <li><a routerLink="/solutions/sauvetage-application-nodejs" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Sauvetage Node.js</a></li>
              <li><a routerLink="/simulateur-cii" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Simulateur CII</a></li>
              <li><a routerLink="/agence-web-chateauroux-paris" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">L'Agence Mesh Box</a></li>
              <li><a routerLink="/contact" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Contact & Rendez-vous</a></li>
              <li><a routerLink="/mentions-legales" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Mentions Légales</a></li>
              <li><a routerLink="/privacy" style="text-decoration: none; color: var(--muted); font-size: 0.9rem;">Politique de Confidentialité</a></li>
          </ul>
      </div>
    </div>
    <div class="copyright" style="border-top: 1px solid var(--border); padding-top: 2rem; text-align: center; color: var(--muted); font-size: 0.85rem;">
      © <span id="year">{{ 2026 }}</span> Mesh Box Agency. Tous droits réservés.
    </div>
  </div>
</footer>

<app-chat-widget></app-chat-widget>
